// AlpineJS
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

// LazySizes
import 'lazysizes'

var menyOpen=document.querySelector("#hamburgerMenyOpen");
var menyClose=document.querySelector("#hamburgerMenyClose");

var menuOpen = false;

menyOpen.addEventListener("click", function () {
    menyOpen.classList.toggle("hidden");
    menyClose.classList.toggle("hidden");
    menuOpen = true;
    document.querySelector("#popupElement").classList.add("hidden");
    toggleMenu();
});

menyClose.addEventListener("click", function () {
    menyOpen.classList.toggle("hidden");
    menyClose.classList.toggle("hidden");
    menuOpen = false;
    document.querySelector("#popupElement").classList.add("hidden");
    toggleMenu();
});

function toggleMenu() {
    document.querySelector("#megaMeny").classList.toggle('hidden');
    if (menuOpen) {
        document.body.style.overflow = "hidden";
    }
    else {
        document.body.style.overflow = "scroll";
    }
}

document.querySelector('#popupCloseButton').addEventListener("click", function () {
    document.querySelector("#popupElement").classList.add("hidden");
    document.querySelector('#popup').parentElement.classList.remove("active");
})
document.querySelector('#popupBg').addEventListener("click", function () {
    document.querySelector("#popupElement").classList.add("hidden");
    document.querySelector('#popup').parentElement.classList.remove("active");
})
document.querySelector('#popup').addEventListener("click", function () {
    document.querySelector("#popupElement").classList.remove("hidden");
    document.querySelector('#popup').parentElement.classList.add("active");
})

document.querySelector('#scrollToContacts').addEventListener("click", function () {
    
      scrollToTargetAdjusted(document.querySelector('#contacts'), 0);

})

function scrollToTargetAdjusted(el, offset) {

    var element = el;

    var headerOffset = offset;

    var elementPosition = element.getBoundingClientRect().top;

    var offsetPosition = elementPosition - headerOffset;



    window.scrollTo({

        top: offsetPosition,

        behavior: "smooth"

    });

}